// google analytics
export const reportGA = (): void => {
  if (BF.fx.collectionSlug()) {
    BF.fx.dataLayerPush(
      {
        brandfolder: BF.fx.slug(),
        collection: BF.fx.collectionSlug(),
        event: `AssetShareFrom${BFG.resource.type}`
      }
    );
  } else {
    BF.fx.dataLayerPush(
      {
        brandfolder: BF.fx.slug(),
        event: `AssetShareFrom${BFG.resource.type}`
      }
    );
  }
};
